import moment from 'moment-timezone';

export class CompanyRateMatrixLoaderAudit {
	public id: number;
	public finishedAt: Date;
	public amount: number;
	public errors: string;
	public warnings: string;
	public isProcessed: boolean;

	constructor(companyRateMatrixLoaderAudit?: CompanyRateMatrixLoaderAudit) {
		Object.assign(this, companyRateMatrixLoaderAudit);

		this.finishedAt = this.finishedAt ? new Date(moment(this.finishedAt).format('MMM DD, YYYY hh:mm:ss a')) : this.finishedAt;
	}
}
